import $https from '@/plugins/axios'

let state = {
  menuList: null
}

const getters = {
  menuList: state => {
    return state.menuList
  }
}

const mutations = {
  SET_MENU_LIST: (state, menuList) => {
    state.menuList = menuList
  }
}

const actions = {
  async GetMenuList ({ commit }) {
    const responseList = await Promise.all([
      $https.axios({ method: 'get', url: 'menu/all' }),
      $https.axios({ method: 'get', url: 'menu/list' })
    ])

    const responseData1 = responseList[0]
    const responseData2 = responseList[1]

    const plan = 2
    if (plan === 1) {
      // 方案1 已经没有维护
      const findMenu = (menuId, menuList) => {
        for (let theMenu of menuList) {
          if (theMenu.id === menuId) {
            return Object.assign({}, theMenu)
          } else {
            const subMenu = findMenu(menuId, theMenu.sub_menu)
            if (subMenu) {
              const newMenu = Object.assign({}, theMenu)
              newMenu.sub_menu = []
              newMenu.sub_menu.push(subMenu)
              return newMenu
            }
          }
        }
        return null
      }
      const mergeSubMenu = (menu1, menu2) => {
        for (const subMenu2 of menu2.sub_menu) {
          const subMenu1 = menu1.sub_menu.find(_subMenu => _subMenu.id === subMenu2.id)
          if (subMenu1) {
            mergeSubMenu(subMenu1, subMenu2)
          } else {
            menu1.sub_menu.push(subMenu2)
          }
        }
      }
      const finalMenuList = []
      for (let theMenuData of responseData2.data) {
        // 根据id在完整的菜单树里筛选出顶级节点
        const newMenu = findMenu(theMenuData.id, responseData1.data)
        const oldMenu = finalMenuList.find(element => element.id === newMenu.id)
        if (!oldMenu) {
          finalMenuList.push(newMenu)
        } else {
          // 当存在两个一样的顶级节点时，合并节点
          mergeSubMenu(oldMenu, newMenu)
        }
      }
      commit('SET_MENU_LIST', finalMenuList)
      return finalMenuList
    } else {
      // 方案2
      const markMenu = (menuId, menuList) => {
        for (let theMenu of menuList) {
          if (theMenu.id === menuId) {
            theMenu.canShow = true
            return true
          } else {
            const canShow = markMenu(menuId, theMenu.sub_menu)
            if (canShow) {
              return true
            }
          }
        }
        return false
      }
      const adjustMenu = (menuList) => {
        const newMenuList = []
        for (let theMenu of menuList) {
          if (theMenu.canShow) {
            delete theMenu.canShow
            newMenuList.push(theMenu)
          } else {
            const newSubMenuList = adjustMenu(theMenu.sub_menu)
            if (newSubMenuList.length) {
              theMenu.sub_menu = newSubMenuList
              newMenuList.push(theMenu)
            }
          }
        }
        return newMenuList
      }
      const sortMenu = (menuList) => {
        menuList.sort((menu1, menu2) => {
          return menu1.menuSort - menu2.menuSort
        })
        for (let theMenu of menuList) {
          if (theMenu.sub_menu) {
            sortMenu(theMenu.sub_menu)
          }
        }
      }
      const menuList = responseData1.data
      for (let theMenuData of responseData2.data) {
        markMenu(theMenuData.id, menuList)
      }
      const finalMenuList = adjustMenu(menuList)
      sortMenu(finalMenuList)
      // finalMenuList.splice(0, 0, { menuName: 'home', menuText: '工作台' })
      commit('SET_MENU_LIST', finalMenuList)
      return finalMenuList
    }
  },
  ClearMenuList ({ commit }) {
    commit('SET_MENU_LIST', null)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/menu.js